import React from 'react';

const NoData = () => {
    return <div>
               <span style={{ fontSize: 'medium' }}>No data available</span>
          </div>
}

export default NoData;